import { CloseCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { OrderModel } from "@app/interfaces/order";
import { Button, Card, message, Modal, Space, Upload, UploadProps } from "antd";
import React from "react";
import { MdAttachFile } from "react-icons/md";
import { FaImages } from "react-icons/fa";

interface ModalProps {
  open: boolean;
  onUpload: (values: any) => void;
  onCancel: () => void;
}

const UploadImage: React.FC<ModalProps> = ({ open, onUpload, onCancel }) => {
  const [fileList, setFileList] = React.useState<any[]>([]);

  const props: UploadProps = {
    name: 'documents',
    multiple: true,
    fileList: fileList,
    accept: 'image/*',
    listType: 'picture-card',
    beforeUpload: (file) => {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error(`${file.name} is not an image file`);
        return Upload.LIST_IGNORE;
      }

      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error('Image must be smaller than 5MB!');
        return Upload.LIST_IGNORE;
      }

      return false;
    },
    onChange(info) {
      setFileList(info.fileList);

      if (info.file.status === 'removed') {
        setFileList(info.fileList);
      }
    },
    onPreview: async (file) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj as File);
      }

      const image = file.url || file.preview;
      const newWindow = window.open('');
      if (newWindow) {
        newWindow.document.write(`<img src="${image}" alt="${file.name}" style="max-width: 100%; height: auto;" />`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const getBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUpload = () => {
    if (fileList.length === 0) {
      message.warning("Vui lòng chọn ít nhất một hình ảnh.");
      return;
    }
    
    onUpload(fileList); // Pass fileList to onUpload
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={600}
      title={
        <span>
          <FaImages /> Upload hình ảnh
        </span>
      }
      style={{ top: 20 }}
      closable={false}
      footer={[
        <Space>
          <Button onClick={handleUpload} type="primary"><UploadOutlined /> Upload</Button>
          <Button onClick={onCancel} type="primary" danger> <CloseCircleOutlined /> Bỏ qua</Button>
        </Space>
      ]}
    >
      <Card className="mt-3">
        <Upload {...props}>
          <PlusOutlined />  Upload
        </Upload>
      </Card>
      <div className="text-primary mt-2 text-right"><MdAttachFile /> Đính kèm hình ảnh tối đa 5MB và chấp nhận các loại hình ảnh (image.*).</div>
    </Modal>
  )
}

export default UploadImage;